<template>
  <div class="sys-face-page main-layout">
    <CCollapseItem>
      <template slot="title-left"> 人脸识别 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom" shadow="never">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <div class="opt-btn" title="新增" @click="goto('')">
            <i class="iconfont icon-add"></i>
          </div>
          <div class="opt-btn" title="批量导入" @click="dialogVisible = true">
            <i class="iconfont icon-daoru3"></i>
          </div>
          <div class="opt-btn" title="同步基础信息" @click="updateFaceData">
            <i class="iconfont icon-async"></i>
          </div>
          <div class="opt-btn" title="允许通过" @click="handleAccess">
            <i class="iconfont icon-access"></i>
          </div>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>
      <div class="div-scroll">
        <c-table
          :index="true"
          :data="pageData"
          @selectionChange="selectionChange"
          :tableColumns="tableColumns"
          :pagination="pageParams"
          @change="pageGet"
          v-loading="pageLoading"
          @edit="goto"
          @delete="pageDel"
        >
          <template slot="custom" slot-scope="scope">
            <el-image
              style="width: 50px; height: 50px"
              :src="scope.row.url"
              :preview-src-list="scope.row.urls"
            >
            </el-image>
          </template>
        </c-table>
      </div>
    </el-card>
    <!-- 新增和编辑弹框 -->
    <el-dialog
    :append-to-body='true'
      :title="title"
      :visible.sync="dialogFormVisible"
      @close="handleDialogClose"
      width="50%"
    >
      <c-form
        v-model="handleData"
        :formRules="formRules"
        label-width="150px"
        ref="cForm"
        @submit="submit"
        @resetFields="resetFields"
        class="add-form"
      >
        <c-form-item :formItems="formItems" ref="cFormItem" />
        <el-form-item label="上传人脸信息" prop="url">
          <el-upload
            action="/face/sysUserFaceInfo/uploadFile"
            accept="image/jpeg,image/jpg,image/png,image/bmp"
            :limit="1"
            list-type="picture-card"
            :headers="requestHeaders"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-error="handleError"
            ref="imageUpload"
            :file-list="imageList"
          >
            <i class="el-icon-plus" slot="default"></i>
          </el-upload>
        </el-form-item>
      </c-form>
    </el-dialog>
    <!-- 添加导入弹框 -->
    <el-dialog
    :append-to-body='true'
      title="上传文件"
      :visible.sync="dialogVisible"
      @close="handleDialogClose"
      width="30%"
      custom-class="upload-dialog"
    >
      <div class="upload-container">
        <el-upload
          ref="upload"
          class="upload-box"
          accept=".zip"
          drag
          :headers="requestHeaders"
          action="/face/sysUserFaceInfo/importFaceInfoByZip"
          :on-success="uploadSuccess"
          :on-error="uploadError"
          style="margin: 0 auto"
        >
          <!-- :before-upload="beforeUpload" -->
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <div class="tips">
          注意：只能上传zip格式的压缩包，压缩包中的图片必须以学生高考报名号或身份证号命名!
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import MPage from "@/mixins/MPage.js";
// import MHandle from "@/mixins/MHandle.js";
import CSearch from "@/components/CSearch/index.vue";
import CTable from "@/components/CTable/index.vue";
import TableBtns from "@/components/TableBtns/index.vue";
import CForm from "@/components/CForm/index.vue";
import CFormItem from "@/components/CFormItem";
import Configs from "./data/face";
import qs from "qs";
export default {
  components: {
    CSearch,
    CTable,
    TableBtns,
    CForm,
    CFormItem,
  },
  data() {
    let { searchItems, tableColumns, formItems, formRules } = Configs(this);
    return {
      SUCCESS_CODE: "",
      token: "",
      isFold: false,
      value: "",
      searchItems,
      tableColumns,
      formItems,
      formRules,
      dialogFormVisible: false,
      title: "",
      pageLoading: false,
      pageData: [],
      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        currentPage: 0,
      },
      searchParams: {
        name: "",
        sex: "",
        idCard: "",
      },
      defaultHandleData: {
        name: "",
        idCard: "",
        sex: null,
        tenantId: "test",
        url: "",
      },
      handleData: {},
      imageUrl: "",
      imageList: [],
      // uploadDisabled: false,
      requestHeaders: {},
      dialogVisible: false, // 控制上传弹框
      idList: [], // 身份证号数组
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE_MODEL;
    this.token = localStorage.getItem("token");
    this.handleData = Object.assign({}, this.defaultHandleData);
    this.requestHeaders = {
      token: this.token,
      tenantId: "test",
    };
  },
  mounted() {
    this.pageGet(true);
  },
  methods: {
    // 新增或变价
    goto(data, type) {
      let id = data.id;
      this.handleData = Object.assign({}, this.defaultHandleData);
      this.formItems[1].disabled = false;
      this.dialogFormVisible = true;
      if (id) {
        this.title = "编辑";
        this.formItems[1].disabled = true;
        this.getFaceById(id);
      } else {
        this.title = "添加";
      }
    },
    // 表格复选框操作（获取选中行）
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.idCard);
        });
        this.idList = idList;
        console.log(idList);
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.searchParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    // 新增和编辑人脸数据
    saveAndUpdate() {
      let params = Object.assign({}, this.handleData);
      console.log(params);
      this.$http
        .post("/face/sysUserFaceInfo/saveOrUpdateByFaceInfo", params, {
          headers: {
            tenantId: "test",
          },
        })
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success(res.msg);
            this.dialogFormVisible = false;
            this.pageGet(true);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    submit() {
      if (this.imageUrl) {
        // let flag = false;
        // if (this.handleData.id && this.handleData.id != 0) {
        //   flag = this.imageUrl === this.handleData.originImage;
        // }
        // if (flag) {
        //   this.handleUpdate(this.handleData);
        // } else {
        //   let formData = new FormData();
        //   formData.append("file", this.imageUrl);
        //   formData.append("jsonStr", JSON.stringify(this.handleData));
        //   console.log(formData);
        //   this.handleSave(formData);
        // }
        this.saveAndUpdate();
      } else {
        this.$message.warning("请上传图片！");
      }
    },
    resetFields() {
      this.imageUrl = null;
      this.imageList = [];
      this.dialogFormVisible = false;
    },
    handleDialogClose() {
      this.resetFields();
    },
    pageGet(tag) {
      if (tag === true) {
        this.pageData = [];
        this.pageParams.pageSize = 10;
        this.pageParams.pageNum = 1;
        this.pageParams.total = 0;
        this.pageParams.currentPage = 0;
      }
      this.pageLoading = true;
      this.$http
        .post(
          "/face/sysUserFaceInfo/listPage",
          { ...this.searchParams, ...this.pageParams },
          { headers: { tenantId: "test" } }
        )
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            let data = res.data;
            this.pageData = data.records;
            this.pageParams.total = data.total;
            this.pageParams.currentPage = data.current;
          } else {
            this.$message.error(`获取数据失败，${res.msg}`);
          }
          this.pageLoading = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          console.error(err);
          this.$message.error(`获取数据失败，${err}`);
        });
    },
    pageDel(params, title = "此操作将永久删除该数据, 是否继续?") {
      console.log(params);
      this.$confirm(title, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$http
            .post(
              "/face/sysUserFaceInfo/deleteFaceById",
              qs.stringify({ id: params }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                  tenantId: "test",
                },
              }
            )
            .then((res) => {
              if (res.code == this.SUCCESS_CODE) {
                this.$message({
                  message: "恭喜你，删除成功！",
                  type: "success",
                });
                this.pageGet(true);
              } else {
                this.$message.error(`删除数据失败，${res.msg}`);
              }
            })
            .catch((err) => {
              console.warn(`删除数据失败，${err}`);
              this.$message.error(`删除数据失败，${err}`);
            });
        })
        .catch((err) => console.warn(err));
    },
    // 根据人脸ID获取详情
    getFaceById(id) {
      this.$http
        .post("/face/sysUserFaceInfo/getFaceById", qs.stringify({ id }), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            tenantId: "test",
          },
        })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            console.log(res.data);
            this.handleData = Object.assign({}, res.data);
            this.imageUrl = res.data.url;
            this.imageList.push({
              url: res.data.url,
              name: res.data.idCard,
              id: res.data.idCard,
            });
          }
        });
    },
    // 新增或编辑(照片更新重新上传的情况)
    handleSave(params) {
      this.$http
        .post("/face/sysUserFaceInfo/saveOrUpdateFaceByFile", params, {
          headers: {
            "Content-Type":
              "multipart/form-data;boundary = " + new Date().getTime(),
            tenantId: "test",
          },
        })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.pageGet(true);
            this.$message.success(res.msg);
            this.dialogFormVisible = false;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 编辑（照片不更新的 情况
    handleUpdate(params) {
      this.$http
        .post("/face/sysUserFaceInfo/saveOrUpdateFaceByBase64", params, {
          headers: {
            // "Content-Type": "application/x-www-form-urlencoded",
            tenantId: "test",
          },
        })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.pageGet(true);
            this.$message.success(res.msg);
            this.dialogFormVisible = false;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 图片上传成功
    handleSuccess(res, file, fileList) {
      // console.log(res);
      // console.log(fileList);
      if (res.code == this.SUCCESS_CODE) {
        file.url = res.url;
        this.imageUrl = res.url;
        this.handleData.url = this.imageUrl;
        this.imageList = fileList;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 移除图片
    handleRemove(file, fileList) {
      this.imageUrl = null;
      this.imageList = [];
    },
    // 图片上传超出一张时提醒
    handleExceed(file, fileList) {
      this.$message.warning("只能上传一张图片，请先删除后上传！");
    },
    // 图片上传失败
    handleError(err) {
      this.$message.error("上传失败，" + err);
    },
    // 人脸图片导入前的格式校验
    beforeUpload(file) {
      console.log(file);
      if (file.type != "application/zip") {
        this.$message.error("上传文件只能是zip格式的压缩包!");
        return false;
      }
    },
    uploadSuccess(res, file, fileList) {
      if (res.code == this.SUCCESS_CODE) {
        this.$message.success(`导入数据成功！${res.msg}`);
        this.$refs.upload.clearFiles();
        this.dialogVisible = false;
        this.pageGet(true);
      } else {
        this.$message.error(`导入数据失败！${res.msg}`);
      }
    },
    uploadError() {
      this.$message.error("导入数据失败，" + err);
    },
    // 同步更新人脸数据
    updateFaceData() {
      this.pageLoading = true;
      this.$http
        .get("/face/sysUserFaceInfo/syncFaceInfo", {
          headers: {
            tenantId: "test",
          },
        })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success(`${res.msg},共更新${res.data}条数据`);
            this.pageGet(true);
          } else {
            this.$message.error(res.msg);
          }
          this.pageLoading = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          this.$message.error(err);
        });
    },
    handleAccess() {
      if (this.idList.length) {
        this.access(this.idList);
      } else {
        this.$message({
          message: "请选择需要操作的数据！",
          type: "warning",
        });
      }
    },
    access(data) {
      // 允许通过
      this.pageLoading = true;
      this.$http
        .post("/face/sysUserFaceTime/skipFaceAuth", data, {
          headers: {
            tenantId: "test",
          },
        })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success(res.msg);
            this.idList = [];
            this.pageGet(true);
          } else {
            this.$message.error(res.msg);
          }
          this.pageLoading = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          this.$message.error(err);
        });
    },
  },
};
</script>


